import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const LancamentoPagamentosList = (props) => <DefaultDataTable data={props} />
